export default {
  overview: "Overview",
  auth: {
    signInBadge: "Workspace access",
    signInTitle: "Sign in",
    signInSubtitle: "Use your company email to continue where you left off.",
    signInHint: "Need an account? Ask your admin to invite you.",
  },
  apiKeys: {
    title: "API Keys",
    description: "Generate and manage keys that allow your tools to talk to the Alkana API.",
    createNew: "New API key",
    createDialogTitle: "Create API key",
    createDialogDescription: "Give each key a clear name so you can safely rotate them later.",
    createDialogFirstKey: "Your first workspace key will be created automatically.",
    nameLabel: "Key name",
    namePlaceholder: "e.g. Production",
    create: "Create key",
    creating: "Creating...",
    success: "Success",
    error: "Something went wrong",
    enterKeyName: "Please enter an API key name",
    keyCreated: "API key created",
    keyDeleted: "API key deleted",
    keyRegenerated: "API key regenerated",
    copyKey: "Copy API key",
    showKey: "Show full key",
    hideKey: "Hide full key",
    copied: "Copied",
    keyCopied: "API key copied to clipboard",
    noKeys: "No API keys yet",
    noKeysDescription: "Create your first key to start using the API.",
    activeKeysCaption: "Active API keys",
    tableHeaders: {
      name: "Name",
      createdAt: "Created",
      lastUsed: "Last used",
      actions: "Actions",
    },
    defaultKey: "Default",
    unused: "Unused",
    regenerate: "Regenerate",
    regenerating: "Regenerating...",
    cancel: "Cancel",
    regenerateConfirmTitle: "Regenerate API key?",
    regenerateConfirmDescription:
      "The existing key will stop working immediately and cannot be recovered.",
    keyCreatedTitle: "Save this API key",
    keyCreatedDescription:
      "You will only see this value once. Copy it somewhere safe before closing.",
    keyRegeneratedTitle: "API key regenerated",
    keyRegeneratedDescription:
      "Copy the new key and update any integrations. The previous key no longer works.",
    createError: "Failed to create API key",
    deleteError: "Failed to delete API key",
    fetchError: "Failed to load API keys",
    regenerateError: "Failed to regenerate API key",
  },
} as const;
